import { Fragment, useState } from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  DvrOutlined,
  Diversity2Outlined,
  Healing,
  HomeOutlined,
  LocalPharmacyOutlined,
  DriveFileRenameOutline,
  MedicationOutlined,
  ImageOutlined,
  TaskOutlined,
  SentimentSatisfiedOutlined,
  RestaurantMenu,
  VerifiedUserOutlined,
  ExpandMore,
  MonitorHeartOutlined,
  MasksOutlined,
  SickOutlined,
  PsychologyOutlined,
  ErrorOutlineOutlined,
  AutorenewOutlined,
} from '@mui/icons-material';

import Survey from '../Survey';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import useNotification from 'hooks/useNotification';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  coachRef: any;
}

const MenuRecords = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth, coachRef } = props;

  const { student_uuid } = useStudent();
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const { onUpdateSurveyType } = useSurvey();

  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);

  const menus = [
    {
      icon: <DvrOutlined />,
      label: '電子病歷',
    },
    {
      disabled: true,
      icon: <AutorenewOutlined />,
      label: 'SBAR',
      id: 'sbar',
    },
    {
      label: 'SBAR 1',
      toggle: toggle.sbar,
    },
    {
      label: 'SBAR 2',
      toggle: toggle.sbar,
    },
    {
      label: 'SBAR 3',
      toggle: toggle.sbar,
    },
    {
      icon: <Diversity2Outlined />,
      label: '護理交班',
    },
    {
      icon: <Healing />,
      label: '護理交班',
    },
    {
      icon: <HomeOutlined />,
      label: '出院記錄',
    },
    {
      icon: <LocalPharmacyOutlined />,
      label: '處方記錄',
    },
    {
      icon: <DriveFileRenameOutline />,
      label: '護理歷史',
    },
    {
      icon: <MedicationOutlined />,
      label: '用藥記錄',
    },
    {
      icon: <ImageOutlined />,
      label: '放射攝影紀錄',
    },
    {
      icon: <TaskOutlined />,
      label: '臨床病理學',
    },
    {
      disabled: true,
      icon: <MonitorHeartOutlined />,
      label: '臨床觀察記錄',
      id: 'clinical_obv',
    },
    {
      label: '生命體徵記錄',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'I/O 輸液輸入',
      toggle: toggle.clinical_obv,
    },
    {
      label: '血糖記錄表',
      toggle: toggle.clinical_obv,
    },
    {
      label: '臨床觀察\n(重症監護室)',
      toggle: toggle.clinical_obv,
    },
    {
      disabled: true,
      icon: <SentimentSatisfiedOutlined />,
      label: '患者評估',
      id: 'patient_evaluation',
    },
    {
      label: 'Morse Fall Scale',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '亨普蒂跌倒評估量表',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '布雷登壓瘡風險評估量表',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '需求評估',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '兒童版GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'FOUR量表',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '患者安全報告',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '病人安全通報與學習系統',
      toggle: toggle.patient_evaluation,
    },
    {
      label: '藥物不良反應通報系統',
      toggle: toggle.patient_evaluation,
    },

    {
      icon: <SickOutlined />,
      disabled: true,
      label: '疼痛評估',
      id: 'pain',
    },
    {
      label: 'NRS',
      toggle: toggle.pain,
    },
    {
      label: 'FLACC疼痛評估量表',
      toggle: toggle.pain,
    },
    // {
    //   label: 'CNPS',
    //   toggle: toggle.pain,
    // },
    {
      label: '足功能指數',
      toggle: toggle.pain,
    },
    {
      label: '膝關節損傷與骨關節炎結果評估量表',
      toggle: toggle.pain,
    },
    {
      label: '下肢功能評估量表',
      toggle: toggle.pain,
    },
    {
      label: '頸部殘疾指數',
      toggle: toggle.pain,
    },
    {
      label: 'STarT 背部筛查',
      toggle: toggle.pain,
    },
    {
      icon: <PsychologyOutlined />,
      disabled: true,
      label: '精神病學',
      id: 'mental_health',
    },
    {
      label: '心理健康記錄',
      toggle: toggle.mental_health,
    },
    {
      label: 'BDI',
      toggle: toggle.mental_health,
    },
    {
      label: 'BAI',
      toggle: toggle.mental_health,
    },
    {
      label: 'MMSE',
      toggle: toggle.mental_health,
    },

    {
      disabled: true,
      icon: <MasksOutlined />,
      label: '特殊部分記錄',
      id: 'special',
    },
    {
      label: '手術',
      toggle: toggle.special,
    },
    {
      label: '麻醉记录',
      toggle: toggle.special,
    },
    {
      label: '输血',
      toggle: toggle.special,
    },
    {
      label: '插管',
      toggle: toggle.special,
    },
    {
      label: '心肺復甦',
      toggle: toggle.special,
    },
    {
      label: '透析',
      toggle: toggle.special,
    },
    {
      label: '急诊',
      toggle: toggle.special,
    },
    {
      label: '分娩',
      toggle: toggle.special,
    },
    {
      label: '居家护理记',
      toggle: toggle.special,
    },
    {
      icon: <RestaurantMenu />,
      label: '飲食與營養',
    },
    {
      disabled: true,
      icon: <VerifiedUserOutlined />,
      label: '協議',
      id: 'agreement',
    },
    {
      label: '患者指南',
      toggle: toggle.agreement,
    },
    {
      label: '一般病患同意書',
      toggle: toggle.agreement,
    },
    {
      label: '输血 / 輸血',
      toggle: toggle.agreement,
    },
    {
      label: '清醒鎮靜',
      toggle: toggle.agreement,
    },
    {
      label: '拒絕維生醫療',
      toggle: toggle.agreement,
    },
    {
      label: '住院協議',
      toggle: toggle.agreement,
    },
    {
      label: '入院指南',
      toggle: toggle.agreement,
    },
    {
      label: '入院檢查清單',
      toggle: toggle.agreement,
    },
    {
      label: '跌倒預防教育',
      toggle: toggle.agreement,
    },
    {
      label: '持續性腎臟替代治療',
      toggle: toggle.agreement,
    },
    {
      label: '中心靜脈導管置放',
      toggle: toggle.agreement,
    },
    {
      label: '氣管插管',
      toggle: toggle.agreement,
    },
    {
      label: '身體約束同意書',
      toggle: toggle.agreement,
    },
    // {
    //   icon: <BabyChangingStation />,
    //   label: 'Children Examination',
    // },
    {
      disabled: true,
      icon: <ErrorOutlineOutlined />,
      label: '資訊學與護理',
      id: 'information',
    },
    {
      label: 'Generative\nAI Nursing\nRecord',
      toggle: toggle.information,
    },
    {
      label: 'Chat\nGPT',
      toggle: toggle.information,
    },
    {
      label: 'Google\nGemini',
      toggle: toggle.information,
    },
  ];

  const onClickListItem = (label: string) => {
    if (!student_uuid) return onRequired('REQUIRED.STUDENT');

    if (label === '病人安全通報與學習系統') {
      window.open('https://psnet.ahrq.gov/');
      return;
    } else if (label === '藥物不良反應通報系統') {
      window.open('https://who-umc.org/');
      return;
    } else if (label === 'Generative\nAI Nursing\nRecord') {
      window.open('https://chatbot2-enr-tw.streamlit.app/');
      return;
    } else if (label === 'Chat\nGPT') {
      window.open('https://chat.openai.com/chat');
      return;
    } else if (label === 'Google\nGemini') {
      window.open('https://bard.google.com/');
      return;
    }

    if (!patientInfo) return onRequired('REQUIRED.PATIENT');
    onUpdateSurveyType(label);
  };

  const onClickDisabledItem = (sublabel: string | undefined) => {
    let newToggle = { ...toggle };

    // if (menuDrawerWidth !== 300) {
    //   if (sublabel) newToggle[sublabel] = true;
    //   setToggle(newToggle);
    //   setMenuDrawerWidth(300);
    //   return;
    // }

    if (sublabel === 'sbar') {
      newToggle['sbar'] = !newToggle['sbar'];
      newToggle['clinical_obv'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'clinical_obv') {
      newToggle['clinical_obv'] = !newToggle['clinical_obv'];
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'patient_evaluation') {
      newToggle['patient_evaluation'] = !newToggle['patient_evaluation'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'pain') {
      newToggle['pain'] = !newToggle['pain'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'mental_health') {
      newToggle['mental_health'] = !newToggle['mental_health'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'special') {
      newToggle['special'] = !newToggle['special'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'agreement') {
      newToggle['agreement'] = !newToggle['agreement'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'information') {
      newToggle['information'] = !newToggle['information'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
    }

    setToggle(newToggle);
  };

  return (
    <Fragment>
      {menus.map(({ icon, label, disabled, toggle, id }) => {
        const onClick = () => {
          if (disabled) onClickDisabledItem(id);
          else onClickListItem(label);
        };

        const MoreIcon = () => {
          if (!disabled) return null;
          return <ExpandMore fontSize="small" sx={{ color: '#fff' }} />;
        };

        if (disabled) {
          return (
            <>
              {icon ? (
                <ListItem
                  key={label}
                  disablePadding
                  ref={label === 'Special part Record' ? coachRef : null}
                  sx={{ whiteSpace: 'pre-wrap' }}
                >
                  <ListItemButton
                    onClick={onClick}
                    sx={{
                      display: 'block',
                      width: '80px',
                      height: '80px',
                      padding: '0px',
                      alignItems: 'center',
                      borderRadius: '8px',
                      margin: '7px',
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        margin: '6.5px 0 6px 0',
                        justifyContent: 'center',
                        width: '80px',
                      }}
                    >
                      {icon}
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                      }}
                      primary={label}
                    />
                  </ListItemButton>
                </ListItem>
              ) : toggle ? (
                <ListItem key={label} disablePadding>
                  <ListItemButton
                    onClick={onClick}
                    sx={{
                      display: 'block',
                      width: '80px',
                      height: '80px',
                      padding: '0px',
                      alignItems: 'center',
                      borderRadius: '8px',
                      margin: '7px',
                    }}
                  >
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                      }}
                      primary={label}
                      sx={{ whiteSpace: 'pre-wrap' }}
                    />
                  </ListItemButton>
                </ListItem>
              ) : (
                <></>
              )}
            </>
          );
        }

        return (
          <>
            {icon ? (
              <ListItem
                key={label}
                disablePadding
                ref={label === 'Special part Record' ? coachRef : null}
                sx={{ whiteSpace: 'pre-wrap' }}
              >
                <ListItemButton
                  onClick={onClick}
                  sx={{
                    display: 'block',
                    width: '80px',
                    height: '80px',
                    padding: '0px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    margin: '7px',
                  }}
                >
                  <ListItemIcon
                    sx={{
                      margin: '6.5px 0 6px 0',
                      justifyContent: 'center',
                      width: '80px',
                      '&:hover': {
                        color: 'red',
                      },
                    }}
                  >
                    {icon}
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{
                      fontSize: '12px',
                      textAlign: 'center',
                    }}
                    primary={label}
                  />
                </ListItemButton>
              </ListItem>
            ) : toggle ? (
              <ListItem
                key={label}
                disablePadding
                sx={{
                  width:
                    label === '病人安全通報與學習系統'
                      ? '120px'
                      : label === '藥物不良反應通報系統'
                      ? '150px'
                      : '100px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                <ListItemButton
                  onClick={onClick}
                  sx={{
                    display: 'block',
                    width:
                      label === '病人安全通報與學習系統'
                        ? '120px'
                        : label === '藥物不良反應通報系統'
                        ? '150px'
                        : '100px',
                    height: '80px',
                    padding: '0px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    margin: '7px',
                    backgroundColor: 'white',
                    ':hover': {
                      boxShadow: '1px 0px 3px 0px #E2E2E2',
                      borderRadius: '8px',
                    },
                  }}
                >
                  <div
                    style={{
                      height: '80px',
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'white',
                      marginTop: '-0.5px',
                      borderRadius: '8px',
                    }}
                  >
                    <ListItemText
                      className="DropMenu"
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                        fontWeight: 500,
                      }}
                      primary={label}
                    />
                  </div>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}
          </>
        );
      })}

      <Survey />
    </Fragment>
  );
};

export default MenuRecords;
